import { Popup } from './popup';

const popupCalls = { 
    init() {

        const menu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
        menu.init();

        const account = new Popup('#jsAccountWrap', '#jsOpenAccount', '#jsCloseAccount');
        account.init();

        const help = new Popup('#jsHelpWrap', '#jsOpenHelp', '#jsCloseHelp');
        help.init();

        const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
        cart.init();

        const filter = new Popup('#jsFilterWrap', '#jsOpenFilter', '#jsCloseFilter');
        filter.init();
      
    },


};

export default popupCalls;
